






import { Component, Vue } from 'vue-property-decorator';
import InfoPage from '@/components/info/InfoPage.vue';

@Component({ components: { InfoPage } })
export default class AcceptedCommuneInfo extends Vue {}
